import { initAccordion } from "../../../assets/js/accordion.js";

// Info-boxen: één blok tegelijk open. Zonder JS staan alle blokken open (de dichte stand zit alleen onder [data-info-ready]).
document.querySelectorAll("[data-info-boxes]").forEach((root) => {
	initAccordion({ root, item: ".info-box", toggle: ".box-toggle", panel: ".info-inner", openClass: "open", readyAttr: "data-info-ready" });
});
